module.exports = __webpack_public_path__ + "img/HC1031-01.50b45678.jpg";